import React, { useState } from "react";
import { Box } from "@mui/material";

const polarToCartesian = (cx, cy, r, angleDeg) => {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    x: cx + r * Math.cos(rad),
    y: cy + r * Math.sin(rad),
  };
};

const describeArc = (cx, cy, r, startAngle, endAngle) => {
  const start = polarToCartesian(cx, cy, r, startAngle);
  const end = polarToCartesian(cx, cy, r, endAngle);
  const largeArc = endAngle - startAngle > 180 ? 1 : 0;

  return [
    `M ${cx} ${cy}`,
    `L ${start.x} ${start.y}`,
    `A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`,
    "Z",
  ].join(" ");
};

export default function MultiSelectableSemiCircle() {
  const [activeIndexes, setActiveIndexes] = useState([]);

  const cx = 300;
  const cy = 300;
  const baseRadius = 260; // Increased outer radius
  const innerRadius = baseRadius - 110;

  const segmentTexts = ["Segment 1", "Segment 2", "Segment 3", "Segment 4"];
  const colors = ["#1976d2", "#388e3c", "#f57c00", "#d32f2f"];
  const activeColors = ["#42a5f5", "#66bb6a", "#ffb74d", "#ef5350"];

  const handleToggle = (index) => {
    setActiveIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
      <svg width="600" height="400">
        {[...Array(4)].map((_, index) => {
          const startAngle = 180 + index * 45;
          const endAngle = 180 + (index + 1) * 45;
          const isActive = activeIndexes.includes(index);
          const radius = isActive ? baseRadius + 15 : baseRadius;

          const path = describeArc(cx, cy, radius, startAngle, endAngle);

          // Label positioning (middle of arc)
          const labelAngle = (startAngle + endAngle) / 2;
          const labelPos = polarToCartesian(cx, cy, radius - 40, labelAngle);

          return (
            <g key={index}>
              <path
                d={path}
                fill={isActive ? activeColors[index] : colors[index]}
                style={{ cursor: "pointer", transition: "all 0.3s ease" }}
                onClick={() => handleToggle(index)}
              />
              <text
                x={labelPos.x}
                y={labelPos.y}
                fill="white"
                fontSize="14"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {segmentTexts[index]}
              </text>
            </g>
          );
        })}

        {/* Inner Green Semi-Circle */}
        <path d={describeArc(cx, cy, innerRadius, 180, 360)} fill="#4CAF50" />
        {/* Inner Label */}
        <text
          x={cx}
          y={cy + 30}
          fill="white"
          fontSize="16"
          fontWeight="bold"
          textAnchor="middle"
        >
          Inner Label
        </text>
      </svg>
    </Box>
  );
}
